// import { useState, useEffect, useCallback, useRef } from "react";
// import { StepperV2 } from "@shared/components/StepperV2";
// import BasicDetailsStep from "./BasicDetailsStep";
// import ConsumerCategoriesStep from "./ConsumerCategoriesStep";
// import UtilityServicesStep from "./UtilityServicesStep";
// import { ServiceChargesStep } from "./ServiceChargesStep";
// import { useNavigate, useParams, useLocation } from "react-router-dom";

// export interface PlanListItem {
//   id: number;
//   planName: string;
//   remoteUtilityId: number;
//   shortName: string;
//   description: string | null;
//   category: string;
//   subcategory: string;
//   utilityService: string[];
//   validity: string;
//   utilityUnit: string | null;
//   tax: number;
//   taxType: number;
//   taxTypeDisplay: string;
//   depositAmount: number | null;
//   contract: number;
//   latePaymentAmount: number | null;
//   surcharge: number | null;
//   status: number;
//   createdDate: string;
//   startDate: string | null;
//   securityDeposit: string | null;
//   connectionFee: string | null;
//   processingFees: string | null;

//   creditPeriod: number | null;
//   billingFrequency: number;
//   utilityServiceData: {
//     rate: {
//       [key: string]: {
//         rate: string;
//         type: number;
//         version: string;
//         avgConsumption: string;
//         estimatedAvgBillAmount: string;
//         estimatedAvgConsumption: string;
//       };
//     };
//     utilityServiceCharges: {
//       [key: string]: {
//         fee: string | null;
//         basis: string;
//         frequency: string | null;
//         operation: string;
//         chargeLabel: string;
//         creditPeriod: string | null;
//         utilityService: string;
//       };
//     };
//   };
//   isActive: boolean;
//   statusDisplay: string;
//   billingFrequencyDisplay: string;
//   createdUserRemoteName: string;
//   lastModifiedUserRemoteName: string;
//   categoryCode: string;
//   subCategoryCode: string;
// }

// const PlanStepper = () => {
//   const { action, planId: paramPlanId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   // States
//   const [planId, setPlanId] = useState(paramPlanId || null);
//   const [allStepData, setAllStepData] = useState({});
//   const [isDataLoaded, setIsDataLoaded] = useState(false);

//   // Refs for navigation control
//   const isNavigatingAfterPlanCreation = useRef(false);
//   const planCreationInProgress = useRef(false);

//   // Configuration
//   const stepSlugs = [
//     "basic-details",
//     "consumer-categories",
//     "utility-services",
//     "service-charges",
//   ];

//   // Get initial data from navigation state (for edit mode)
//   const initialData: PlanListItem | undefined = location.state?.initialData;

//   // Transform PlanListItem to step data format
//   const transformPlanToStepData = useCallback((planData: PlanListItem) => {
//     return {
//       0: {
//         // Basic Details step
//         id: planData.id,
//         planId: planData.id,
//         planName: planData.planName,
//         shortName: planData.shortName,
//         description: planData.description || "",
//         billingFrequency: planData.billingFrequency.toString(),
//         taxType: planData.taxType.toString(),
//         taxRate: planData.tax,
//         startDate: planData.startDate,
//         endDate: planData.validity, // Assuming validity is end date
//         remoteUtilityId: planData.remoteUtilityId,
//         processingFees: planData.processingFees,
//         connectionFee: planData.connectionFee,

//         securityDeposit: planData.securityDeposit,
//       },
//       1: {
//         // Consumer Categories step
//         category: planData.category,
//         subcategory: planData.subcategory,
//         categoryCode: planData.categoryCode,
//         subCategoryCode: planData.subCategoryCode,
//       },
//       2: {
//         // Utility Services step
//         utilityService: planData.utilityService,
//         utilityUnit: planData.utilityUnit,
//         rateData: planData.utilityServiceData?.rate || {},
//       },
//       3: {
//         // Service Charges step
//         serviceCharges:
//           planData.utilityServiceData?.utilityServiceCharges || {},
//         depositAmount: planData.depositAmount,
//         latePaymentAmount: planData.latePaymentAmount,
//         surcharge: planData.surcharge,
//         creditPeriod: planData.creditPeriod,
//       },
//     };
//   }, []);

//   // Load data for edit mode
//   // useEffect(() => {
//   //   if (action === "edit" && initialData && !isDataLoaded) {
//   //     console.log(
//   //       "🔄 Loading plan data for edit mode from navigation state:",
//   //       initialData
//   //     );

//   //     // Set planId from initial data
//   //     if (initialData.id && !planId) {
//   //       const initialPlanId = initialData.id.toString();
//   //       console.log("📦 Setting planId from initial data:", initialPlanId);
//   //       setPlanId(initialPlanId);
//   //     }

//   //     // Check for recent localStorage data for this specific plan
//   //     const planSpecificKey = `utility-plan-progress-${initialData.id}`;
//   //     let useLocalStorageData = false;
//   //     let existingStepData = {};

//   //     try {
//   //       const savedData = localStorage.getItem(planSpecificKey);
//   //       if (savedData) {
//   //         const parsed = JSON.parse(savedData);
//   //         const isRecent =
//   //           parsed.timestamp && Date.now() - parsed.timestamp < 3600000; // 1 hour
//   //         const isSamePlan = parsed.planId === initialData.id;

//   //         if (
//   //           isRecent &&
//   //           isSamePlan &&
//   //           Object.keys(parsed.stepData || {}).length > 0
//   //         ) {
//   //           console.log("📦 Using recent localStorage data for this plan");
//   //           useLocalStorageData = true;
//   //           existingStepData = parsed.stepData;
//   //         } else {
//   //           localStorage.removeItem(planSpecificKey);
//   //         }
//   //       }
//   //     } catch (error) {
//   //       console.error("Error reading localStorage:", error);
//   //     }

//   //     // Decide which data to use
//   //     const finalStepData = useLocalStorageData
//   //       ? existingStepData
//   //       : transformPlanToStepData(initialData);

//   //       console.log("📦 Final step data being set:", finalStepData[2]);
//   //     setAllStepData(finalStepData);

//   //     // Update localStorage with current data
//   //     const stepperData = {
//   //       currentStep: 0,
//   //       completedSteps: [0, 1, 2, 3], // Mark all as completed for edit
//   //       skippedSteps: [],
//   //       stepData: finalStepData,
//   //       timestamp: Date.now(),
//   //       version: "1.0.0",
//   //       planId: initialData.id,
//   //     };

//   //     localStorage.setItem(planSpecificKey, JSON.stringify(stepperData));
//   //     localStorage.setItem(
//   //       "utility-plan-progress",
//   //       JSON.stringify(stepperData)
//   //     );

//   //     console.log("✅ Plan data loaded and synced to localStorage");
//   //     setIsDataLoaded(true);
//   //   } else if (action === "edit" && !initialData && planId) {
//   //     // Edit mode without navigation data but with planId (coming from add->edit transition)
//   //     console.log(
//   //       "🔄 Edit mode after plan creation, checking localStorage for planId:",
//   //       planId
//   //     );

//   //     // Try to load from localStorage for this plan
//   //     const planSpecificKey = `utility-plan-progress-${planId}`;
//   //     try {
//   //       const savedData =
//   //         localStorage.getItem(planSpecificKey) ||
//   //         localStorage.getItem("utility-plan-progress");
//   //       if (savedData) {
//   //         const parsed = JSON.parse(savedData);
//   //         if (parsed.stepData && Object.keys(parsed.stepData).length > 0) {
//   //           console.log("📦 Using localStorage data for edit mode");
//   //           setAllStepData(parsed.stepData);
//   //           setIsDataLoaded(true);
//   //           return;
//   //         }
//   //       }
//   //     } catch (error) {
//   //       console.error("Error reading localStorage:", error);
//   //     }

//   //     // If no localStorage data found, this is likely a direct URL access
//   //     console.warn(
//   //       "⚠️ Edit mode without data and no localStorage, redirecting to list"
//   //     );
//   //     // navigate("/onboarding/utility-setup/plans");
//   //   } else if (action === "add") {
//   //     // For add mode, start fresh
//   //     localStorage.removeItem("utility-plan-progress");
//   //     setIsDataLoaded(true);
//   //   } else if (action === "edit" && !initialData && !planId) {
//   //     // Edit mode without both navigation data and planId - definitely invalid
//   //     console.warn(
//   //       "⚠️ Edit mode without initial data or planId, redirecting to list"
//   //     );
//   //     // navigate("/onboarding/utility-setup/plans");
//   //   }
//   // }, [
//   //   action,
//   //   initialData,
//   //   isDataLoaded,
//   //   planId,
//   //   navigate,
//   //   transformPlanToStepData,
//   // ]);

//   // In your existing PlanStepper, in the useEffect that loads data:

// useEffect(() => {
//   if (action === "edit" && initialData && !isDataLoaded) {
//     console.log("🔄 Loading plan data for edit mode");
    
//     // Transform plan data
//     const finalStepData = transformPlanToStepData(initialData);
    
//     // Set the data
//     setAllStepData(finalStepData);
    
//     // Update localStorage
//     const planSpecificKey = `utility-plan-progress-${initialData.id}`;
//     const stepperData = {
//       currentStep: 0,
//       completedSteps: [0, 1, 2, 3],
//       skippedSteps: [],
//       stepData: finalStepData,  // ← This has fresh API data
//       timestamp: Date.now(),
//       version: "1.0.0",
//       planId: initialData.id,
//     };
    
//     localStorage.setItem(planSpecificKey, JSON.stringify(stepperData));
//     localStorage.setItem("utility-plan-progress", JSON.stringify(stepperData));
    
//     setIsDataLoaded(true);
//   }
// }, [action, initialData, isDataLoaded, transformPlanToStepData]);

//   // Handle step data changes
//   const handleStepDataChange = useCallback(
//     (stepIndex: number, stepData: any) => {
//       console.log("📨 Data changed from step:", { stepIndex, stepData });

//       setAllStepData((prev) => ({
//         ...prev,
//         [stepIndex]: stepData,
//       }));

//       // Handle plan creation (add mode only)
//       if (stepIndex === 0 && stepData?.id && !planId && action === "add") {
//         const newPlanId = stepData.id;
//         isNavigatingAfterPlanCreation.current = true;
//         planCreationInProgress.current = true;
//         setPlanId(newPlanId);
//       }
//     },
//     [planId, action]
//   );

//   // Navigate to edit route after plan creation
//   useEffect(() => {
//     if (
//       isNavigatingAfterPlanCreation.current &&
//       planId &&
//       window.location.pathname.includes("/add")
//     ) {
//       const currentHash =
//         window.location.hash.replace("#", "") || "basic-details";
//       const nextUrl = `/plan-tarrif/plan/edit/${planId}#${currentHash}`;
//       navigate(nextUrl, { replace: true });
//       isNavigatingAfterPlanCreation.current = false;

//       setTimeout(() => {
//         planCreationInProgress.current = false;
//       }, 100);
//     }
//   }, [planId, navigate]);

//   // Set planId from URL params
//   useEffect(() => {
//     if (paramPlanId && !planId) {
//       setPlanId(paramPlanId);
//     }
//   }, [paramPlanId, planId]);

//   // Navigation handlers
//   const handleBasicDetailsNext = useCallback(() => {
//     if (isNavigatingAfterPlanCreation.current || !planId) return;
//     const nextStepSlug = stepSlugs[1];
//     navigate(`/plan-tarrif/plan/edit/${planId}#${nextStepSlug}`, {
//       replace: true,
//     });
//   }, [planId, navigate]);

//   const handleStepChange = useCallback(
//     (newStepIndex: number, previousStepIndex: number, stepInfo: any) => {
//       if (
//         planCreationInProgress.current ||
//         isNavigatingAfterPlanCreation.current
//       )
//         return;

//       const slug = stepSlugs[newStepIndex];
//       if (planId) {
//         navigate(`/plan-tarrif/plan/edit/${planId}#${slug}`);
//       } else {
//         navigate(`/plan-tarrif/plan/add#${slug}`);
//       }
//     },
//     [planId, navigate]
//   );

//   const handleStepSave = useCallback(
//     async (stepIndex: number, stepData: any, isDirty: boolean) => {
//       // Update local state
//       setAllStepData((prev) => ({
//         ...prev,
//         [stepIndex]: stepData,
//       }));

//       // Handle plan creation for step 0
//       if (stepIndex === 0 && stepData?.id && !planId) {
//         setPlanId(stepData.id);
//       }

//       // For steps > 0 with planId, call your update API
//       if (stepIndex > 0 && planId) {
//         try {
//           // TODO: Replace with actual API call
//           // await updatePlanStep(planId, stepIndex, stepData);
//           console.log(`Saving step ${stepIndex} for plan ${planId}:`, stepData);
//           return { success: true };
//         } catch (error) {
//           console.error("Failed to save step data:", error);
//           return { success: false, error: error.message };
//         }
//       }

//       return { success: true };
//     },
//     [planId]
//   );

//   const handleComplete = useCallback(
//     (allStepData: any, completedSteps: number[], skippedSteps: number[]) => {
//       // Clear localStorage on completion
//       localStorage.removeItem("utility-plan-progress");
//       if (planId) {
//         localStorage.removeItem(`utility-plan-progress-${planId}`);
//       }

//       alert("Plan has been completed successfully!");
//       navigate("/plan-tarrif/plan-tarrif-landing");
//     },
//     [planId, navigate]
//   );

//   // Step definitions
//   const steps = [
//     {
//       title: "Basic Details",
//       slug: "basic-details",
//       component: (
//         <BasicDetailsStep
//           onDataChange={(data) => handleStepDataChange(0, data)}
//           stepChange={(data) => handleStepDataChange(0, data)}
//           onNext={handleBasicDetailsNext}
//           data={allStepData[0] || {}}
//           setValidationError={(error) =>
//             console.error("Validation Error:", error)
//           }
//           clearValidationError={() => console.log("Clearing validation error")}
//         />
//       ),
//     },
//     {
//       title: "Consumer Categories",
//       slug: "consumer-categories",
//       component: (
//         <ConsumerCategoriesStep
//           onDataChange={(data) => handleStepDataChange(1, data)}
//           data={allStepData[1] || {}}
//           onNext={handleBasicDetailsNext}
//         />
//       ),
//     },
//     {
//       title: "Utility Services",
//       slug: "utility-services",
//       component: (
//         <UtilityServicesStep
//           onDataChange={(data) => handleStepDataChange(2, data)}
//         stepChange={(data) => handleStepDataChange(0, data)}

//           data={allStepData[2] || {}}
//         />
//       ),
//     },
//     {
//       title: "Service Charges",
//       slug: "service-charges",
//       component: (
//         <ServiceChargesStep
//           onDataChange={(data) => handleStepDataChange(3, data)}
//           data={allStepData[3] || {}}
//         />
//       ),
//     },
//   ];

//   // Show loading until data is ready
//   if (!isDataLoaded) {
//     return (
//       <div className="w-full mx-auto p-6">
//         <div className="flex items-center justify-center h-64">
//           <div className="text-center">
//             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
//             <p className="text-gray-600">Loading plan data...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="w-full mx-auto p-6">
//       <div className="mb-6">
//         <h1 className="page-title">
//           {planId ? `Edit Plan: ${planId}` : "Create New Utility Plan"}
//         </h1>
//         <p className="page-subtitle">
//           Follow the steps below to {planId ? "update" : "create"} your utility
//           plan.
//         </p>
//       </div>

//       <StepperV2
//         steps={steps}
//         onStepChange={handleStepChange}
//         onComplete={handleComplete}
//         onStepSave={handleStepSave}
//         enableApiSave={true}
//         saveOnStepChange={true}
//         trackDirtyState={true}
//         persistProgress={true}
//         storageKey={
//           planId ? `utility-plan-progress-${planId}` : "utility-plan-progress"
//         }
//         enableRouting={true}
//         className="w-full"
//         showDraftResume={true} // Only show draft resume for add mode
//       />
//     </div>
//   );
// };

// export default PlanStepper;


import { useState, useEffect, useCallback, useRef } from "react";
import { StepperV2 } from "@shared/components/StepperV2";
import BasicDetailsStep from "./BasicDetailsStep";
import ConsumerCategoriesStep from "./ConsumerCategoriesStep";
import UtilityServicesStep from "./UtilityServicesStep";
import { ServiceChargesStep } from "./ServiceChargesStep";
import { useNavigate, useParams, useLocation } from "react-router-dom";
export interface PlanListItem {
  id: number;
  planName: string;
  remoteUtilityId: number;
  shortName: string;
  description: string | null;
  category: string;
  subcategory: string;
  utilityService: string[];
  validity: string;
  utilityUnit: string | null;
  tax: number;
  taxType: number;
  taxTypeDisplay: string;
  depositAmount: number | null;
  contract: number;
  latePaymentAmount: number | null;
  surcharge: number | null;
  status: number;
  createdDate: string;
  startDate: string | null;
  securityDeposit: string | null;
  connectionFee: string | null;
  processingFees: string | null;
  creditPeriod: number | null;
  billingFrequency: number;
  utilityServiceData: {
    rate: {
      [key: string]: {
        rate: string;
        type: number;
        version: string;
        avgConsumption: string;
        estimatedAvgBillAmount: string;
        estimatedAvgConsumption: string;
      };
    };
    utilityServiceCharges: {
      [key: string]: {
        fee: string | null;
        basis: string;
        frequency: string | null;
        operation: string;
        chargeLabel: string;
        creditPeriod: string | null;
        utilityService: string;
      };
    };
  };
  isActive: boolean;
  statusDisplay: string;
  billingFrequencyDisplay: string;
  createdUserRemoteName: string;
  lastModifiedUserRemoteName: string;
  categoryCode: string;
  subCategoryCode: string;
}
const PlanStepper = () => {
  const { action, planId: paramPlanId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  // States
  const [planId, setPlanId] = useState(paramPlanId || null);
  const [allStepData, setAllStepData] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  // Refs for navigation control
  const isNavigatingAfterPlanCreation = useRef(false);
  const planCreationInProgress = useRef(false);
  // Configuration
  const stepSlugs = [
    "basic-details",
    "consumer-categories",
    "utility-services",
    "service-charges",
  ];
  // Get initial data from navigation state (for edit mode)
  const initialData: PlanListItem | undefined = location.state?.initialData;
  // Transform PlanListItem to step data format
  const transformPlanToStepData = useCallback((planData: PlanListItem) => {
    return {
      0: {
        // Basic Details step
        id: planData.id,
        planId: planData.id,
        planName: planData.planName,
        shortName: planData.shortName,
        description: planData.description || "",
        billingFrequency: planData.billingFrequency.toString(),
        taxType: planData.taxType.toString(),
        taxRate: planData.tax,
        startDate: planData.startDate,
        endDate: planData.validity, // Assuming validity is end date
        remoteUtilityId: planData.remoteUtilityId,
        processingFees: planData.processingFees,
        connectionFee: planData.connectionFee,
        securityDeposit: planData.securityDeposit,
      },
      1: {
        // Consumer Categories step
        category: planData.category,
        subcategory: planData.subcategory,
        categoryCode: planData.categoryCode,
        subCategoryCode: planData.subCategoryCode,
      },
      2: {
        // Utility Services step
        utilityService: planData.utilityService,
        utilityUnit: planData.utilityUnit,
        rateData: planData.utilityServiceData?.rate || {},
      },
      3: {
        // Service Charges step
        serviceCharges:
          planData.utilityServiceData?.utilityServiceCharges || {},
        depositAmount: planData.depositAmount,
        latePaymentAmount: planData.latePaymentAmount,
        surcharge: planData.surcharge,
        creditPeriod: planData.creditPeriod,
      },
    };
  }, []);
  // Load data for edit mode
  useEffect(() => {
    if (action === "edit" && initialData && !isDataLoaded) {
      console.log(
        "🔄 Loading plan data for edit mode from navigation state:",
        initialData
      );
      // Set planId from initial data
      if (initialData.id && !planId) {
        const initialPlanId = initialData.id.toString();
        console.log("📦 Setting planId from initial data:", initialPlanId);
        setPlanId(initialPlanId);
      }
      // Check for recent localStorage data for this specific plan
      const planSpecificKey = `utility-plan-progress-${initialData.id}`;
      let useLocalStorageData = false;
      let existingStepData = {};
      try {
        const savedData = localStorage.getItem(planSpecificKey);
        if (savedData) {
          const parsed = JSON.parse(savedData);
          const isRecent =
            parsed.timestamp && Date.now() - parsed.timestamp < 3600000; // 1 hour
          const isSamePlan = parsed.planId === initialData.id;
          if (
            isRecent &&
            isSamePlan &&
            Object.keys(parsed.stepData || {}).length > 0
          ) {
            console.log("📦 Using recent localStorage data for this plan");
            useLocalStorageData = true;
            existingStepData = parsed.stepData;
          } else {
            localStorage.removeItem(planSpecificKey);
          }
        }
      } catch (error) {
        console.error("Error reading localStorage:", error);
      }
      // Decide which data to use
      const finalStepData = useLocalStorageData
        ? existingStepData
        : transformPlanToStepData(initialData);
      setAllStepData(finalStepData);
      // Update localStorage with current data
      const stepperData = {
        currentStep: 0,
        completedSteps: [0, 1, 2, 3], // Mark all as completed for edit
        skippedSteps: [],
        stepData: finalStepData,
        timestamp: Date.now(),
        version: "1.0.0",
        planId: initialData.id,
      };
      localStorage.setItem(planSpecificKey, JSON.stringify(stepperData));
      localStorage.setItem(
        "utility-plan-progress",
        JSON.stringify(stepperData)
      );
      console.log("✅ Plan data loaded and synced to localStorage");
      setIsDataLoaded(true);
    } else if (action === "edit" && !initialData && planId) {
      // Edit mode without navigation data but with planId (coming from add->edit transition)
      console.log(
        "🔄 Edit mode after plan creation, checking localStorage for planId:",
        planId
      );
      // Try to load from localStorage for this plan
      const planSpecificKey = `utility-plan-progress-${planId}`;
      try {
        const savedData =
          localStorage.getItem(planSpecificKey) ||
          localStorage.getItem("utility-plan-progress");
        if (savedData) {
          const parsed = JSON.parse(savedData);
          if (parsed.stepData && Object.keys(parsed.stepData).length > 0) {
            console.log("📦 Using localStorage data for edit mode");
            setAllStepData(parsed.stepData);
            setIsDataLoaded(true);
            return;
          }
        }
      } catch (error) {
        console.error("Error reading localStorage:", error);
      }
      // If no localStorage data found, this is likely a direct URL access
      console.warn(
        "⚠️ Edit mode without data and no localStorage, redirecting to list"
      );
      // navigate("/onboarding/utility-setup/plans");
    } else if (action === "add") {
      // For add mode, start fresh
      localStorage.removeItem("utility-plan-progress");
      setIsDataLoaded(true);
    } else if (action === "edit" && !initialData && !planId) {
      // Edit mode without both navigation data and planId - definitely invalid
      console.warn(
        "⚠️ Edit mode without initial data or planId, redirecting to list"
      );
      // navigate("/onboarding/utility-setup/plans");
    }
  }, [
    action,
    initialData,
    isDataLoaded,
    planId,
    navigate,
    transformPlanToStepData,
  ]);
  // Handle step data changes
  const handleStepDataChange = useCallback(
    (stepIndex: number, stepData: any) => {
      console.log("📨 Data changed from step:", { stepIndex, stepData });
      setAllStepData((prev) => ({
        ...prev,
        [stepIndex]: stepData,
      }));
      // Handle plan creation (add mode only)
      if (stepIndex === 0 && stepData?.id && !planId && action === "add") {
        const newPlanId = stepData.id;
        isNavigatingAfterPlanCreation.current = true;
        planCreationInProgress.current = true;
        setPlanId(newPlanId);
      }
    },
    [planId, action]
  );
  // Navigate to edit route after plan creation
  useEffect(() => {
    if (
      isNavigatingAfterPlanCreation.current &&
      planId &&
      window.location.pathname.includes("/add")
    ) {
      const currentHash =
        window.location.hash.replace("#", "") || "basic-details";
      const nextUrl = `/plan-tarrif/plan/edit/${planId}#${currentHash}`;
      navigate(nextUrl, { replace: true });
      isNavigatingAfterPlanCreation.current = false;
      setTimeout(() => {
        planCreationInProgress.current = false;
      }, 100);
    }
  }, [planId, navigate]);
  // Set planId from URL params
  useEffect(() => {
    if (paramPlanId && !planId) {
      setPlanId(paramPlanId);
    }
  }, [paramPlanId, planId]);
  // Navigation handlers
  const handleBasicDetailsNext = useCallback(() => {
    if (isNavigatingAfterPlanCreation.current || !planId) return;
    const nextStepSlug = stepSlugs[1];
    navigate(`/plan-tarrif/plan/edit/${planId}#${nextStepSlug}`, {
      replace: true,
    });
  }, [planId, navigate]);
  const handleStepChange = useCallback(
    (newStepIndex: number, previousStepIndex: number, stepInfo: any) => {
      if (
        planCreationInProgress.current ||
        isNavigatingAfterPlanCreation.current
      )
        return;
      const slug = stepSlugs[newStepIndex];
      if (planId) {
        navigate(`/plan-tarrif/plan/edit/${planId}#${slug}`);
      } else {
        navigate(`/plan-tarrif/plan/add#${slug}`);
      }
    },
    [planId, navigate]
  );
  const handleStepSave = useCallback(
    async (stepIndex: number, stepData: any, isDirty: boolean) => {
      // Update local state
      setAllStepData((prev) => ({
        ...prev,
        [stepIndex]: stepData,
      }));
      // Handle plan creation for step 0
      if (stepIndex === 0 && stepData?.id && !planId) {
        setPlanId(stepData.id);
      }
      // For steps > 0 with planId, call your update API
      if (stepIndex > 0 && planId) {
        try {
          // TODO: Replace with actual API call
          // await updatePlanStep(planId, stepIndex, stepData);
          console.log(`Saving step ${stepIndex} for plan ${planId}:`, stepData);
          return { success: true };
        } catch (error) {
          console.error("Failed to save step data:", error);
          return { success: false, error: error.message };
        }
      }
      return { success: true };
    },
    [planId]
  );
  const handleComplete = useCallback(
    (allStepData: any, completedSteps: number[], skippedSteps: number[]) => {
      // Clear localStorage on completion
      localStorage.removeItem("utility-plan-progress");
      if (planId) {
        localStorage.removeItem(`utility-plan-progress-${planId}`);
      }
      alert("Plan has been completed successfully!");
      navigate("/plan-tarrif/plan-tarrif-landing");
    },
    [planId, navigate]
  );
  // Step definitions
  const steps = [
    {
      title: "Basic Details",
      slug: "basic-details",
      component: (
        <BasicDetailsStep
          onDataChange={(data) => handleStepDataChange(0, data)}
          stepChange={(data) => handleStepDataChange(0, data)}
          onNext={handleBasicDetailsNext}
          data={allStepData[0] || {}}
          setValidationError={(error) =>
            console.error("Validation Error:", error)
          }
          clearValidationError={() => console.log("Clearing validation error")}
        />
      ),
    },
    {
      title: "Consumer Categories",
      slug: "consumer-categories",
      component: (
        <ConsumerCategoriesStep
          onDataChange={(data) => handleStepDataChange(1, data)}
          data={allStepData[1] || {}}
          onNext={handleBasicDetailsNext}
        />
      ),
    },
    {
      title: "Utility Services",
      slug: "utility-services",
      component: (
        <UtilityServicesStep
          onDataChange={(data) => handleStepDataChange(2, data)}
          data={allStepData[2] || {}}
        />
      ),
    },
    {
      title: "Service Charges",
      slug: "service-charges",
      component: (
        <ServiceChargesStep
          onDataChange={(data) => handleStepDataChange(3, data)}
          data={allStepData[3] || {}}
        />
      ),
    },
  ];
  // Show loading until data is ready
  if (!isDataLoaded) {
    return (
      <div className="w-full mx-auto p-6">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading plan data...</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="w-full mx-auto p-6">
      <div className="mb-6">
        <h1 className="page-title">
          {planId ? `Edit Plan: ${planId}` : "Create New Utility Plan"}
        </h1>
        <p className="page-subtitle">
          Follow the steps below to {planId ? "update" : "create"} your utility
          plan.
        </p>
      </div>
      <StepperV2
        steps={steps}
        onStepChange={handleStepChange}
        onComplete={handleComplete}
        onStepSave={handleStepSave}
        enableApiSave={true}
        saveOnStepChange={true}
        trackDirtyState={true}
        persistProgress={true}
        storageKey={
          planId ? `utility-plan-progress-${planId}` : "utility-plan-progress"
        }
        enableRouting={true}
        className="w-full"
        showDraftResume={true} // Only show draft resume for add mode
      />
    </div>
  );
};
export default PlanStepper;